import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=5e09455c&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09455c",
  null
  
)

component.options.__file = "page1.vue"
export default component.exports